import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseEmptyDocumentOrginalNumberError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.empty-document-orginal-number-error.message');
    }
}
